// extracted by mini-css-extract-plugin
module.exports = {"ediStatusTag":"style_ediStatusTag__1PY9t"};